import { FC, Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import {
  faSearchPlus,
  faChevronDown,
} from '@awesome.me/kit-e270131d0a/icons/classic/regular'
import { Icon, Text } from '@saasalerts/ui'

export type DropdownMenuLinkType = {
  title: string
  href?: string
}

interface DropdownMenuProps {
  itemList: DropdownMenuLinkType[]
  icon?: React.ReactElement
  label?: string
}

const MenuLink: FC<React.PropsWithChildren<{ item: DropdownMenuLinkType }>> = ({
  item,
}) => {
  return (
    <a
      href={item.href}
      target="_blank"
      className="block px-2 py-[5px] text-sm leading-[22px] text-blue-1000 hover:bg-black/10 active:bg-black/20 dark:text-gray-200 dark:hover:bg-white/10 dark:active:bg-black/20"
      rel="noreferrer noopener"
    >
      {item.title}
    </a>
  )
}

export const DropdownMenu: FC<React.PropsWithChildren<DropdownMenuProps>> = ({
  itemList,
  icon,
  label,
}) => {
  return (
    <Menu as="div" className="relative z-10">
      {({ open }) => (
        <>
          <div>
            <Menu.Button
              className={`dark:text-dark-text flex w-full cursor-default items-center justify-between rounded border border-gray-400 bg-white px-3 py-[5px] text-left hover:border-gray-500 dark:border-gray-800 dark:bg-dark-surface dark:hover:border-gray-600 ${
                open
                  ? 'border-brand-500 hover:border-brand-500 dark:border-brand-400 dark:hover:border-brand-400'
                  : ''
              }`}
            >
              {icon ? icon : <Icon icon={faSearchPlus} size="1x" />}
              {label ?? <Text>Drilldown</Text>}
              <Icon icon={faChevronDown} size="1x" />
            </Menu.Button>
          </div>
          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              aria-expanded="true"
              className="absolute right-0 mt-2 min-w-full origin-top-right rounded-md bg-white py-1 shadow-[0_12px_32px_rgba(0,29,48,0.12),_0_2px_8px_rgba(0,29,48,0.06)] ring-1 ring-black/5 focus:outline-none dark:bg-dark-surface dark:shadow-[0_12px_32px_rgba(0,0,0,0.4),_0_2px_8px_rgba(0,0,0,0.2)]"
            >
              {itemList.map((item) => (
                <Menu.Item key={item.title}>
                  <MenuLink item={item} />
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  )
}
